// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tip-line[data-v-a8c52498] {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.icon-line[data-v-a8c52498] {\n  font-size: 12px;\n  color: gray;\n  margin-left: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
